import {
  FieldValues,
  useForm,
  UseFormProps,
  UseFormReturn
} from 'react-hook-form';

/**
 * When validation runs, stated once rather than inherited from react-hook-form
 * in every form:
 *
 * - `onSubmit` — nothing is marked wrong until Save, so a form being filled in
 *   for the first time is never scolded for fields not reached yet.
 * - `onChange` on re-validation — once a field has failed, it re-checks as it
 *   is typed into, so the error clears where the correction is made rather
 *   than on the next Save.
 *
 * The discussion guide editor under `configure/topics` sets its own timing.
 */
const VALIDATION_TIMING = {
  mode: 'onSubmit',
  reValidateMode: 'onChange'
} as const;

/** `useForm` with the app's validation timing. Pass anything else through. */
export function useAppForm<
  TFieldValues extends FieldValues = FieldValues,
  TContext = any,
  TTransformedValues = TFieldValues
>(
  props?: UseFormProps<TFieldValues, TContext, TTransformedValues>
): UseFormReturn<TFieldValues, TContext, TTransformedValues> {
  return useForm<TFieldValues, TContext, TTransformedValues>({
    ...VALIDATION_TIMING,
    ...props
  });
}
